var React = require('react');

function ConveyorBelt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M128 240V16a16 16 0 0 1 16-16h352a16 16 0 0 1 16 16v224a16 16 0 0 1-16 16H144a16 16 0 0 1-16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M544 320H96a96 96 0 0 0 0 192h448a96 96 0 0 0 0-192zM128 448a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm192 0a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm192 0a32 32 0 1 1 32-32 32 32 0 0 1-32 32zM384 128V0H256v128l64-32z","className":"fa-primary","key":2})]);
}

ConveyorBelt.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = ConveyorBelt;

ConveyorBelt.default = ConveyorBelt;
